import { useMemo } from 'react'
import { eventRegionId } from '@shared/regions'
import { popularEventIds } from '@shared/ranking'
import { isEventActive } from '../lib/formatDate'
import { getNow } from '../lib/clock'
import type { Event } from '../types'

const EMPTY: Set<string> = new Set()

/**
 * Ids of the region's Popular events (top ~10% by global score, with real
 * interest). Empty until `ready`, and with no region (Everywhere) — there's
 * no single region to rank against. Keyed on `today` rather than a Date so
 * the memo holds between renders; `getNow()` inside keeps the E2E clock.
 */
export function usePopularEventIds(events: Event[], regionId: string | null, ready: boolean, today: string): Set<string> {
  return useMemo(() => {
    if (!ready || !regionId) return EMPTY
    const now = getNow()
    return popularEventIds(events.filter(e => !e.cancelled && isEventActive(e, now) && eventRegionId(e) === regionId))
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `today` stands in for getNow()
  }, [events, regionId, ready, today])
}
